import axios from 'axios'

import { userActions } from '../_actions'
import { apiConstants } from '../_constants'

export const apiService = {
  getHeaders,
  handleResponse,
  fetchWithoutAuthGet: (url) => axios.get(`${apiConstants.API_SERVER_URL}${url}`, {
    headers: {
    }
  }),

  fetchWithoutAuthPost: (url, data) => axios.post(`${apiConstants.API_SERVER_URL}${url}`, data, {
    headers: {
    }
  }),

  fetchWithoutAuthPut: (url, data) => axios.put(`${apiConstants.API_SERVER_URL}${url}`, data, {
    headers: {
    }
  }),

  fetchLogin: (url, data) => axios.post(`${apiConstants.API_SERVER_URL}${url}`, data, {
    headers: {
      'Content-Type': 'application/json',
    }
  }),

  fetchFilePost: (url, data) => axios.post(`${apiConstants.API_SERVER_URL}${url}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),

  fetchAuthGet: (url) => axios.get(`${apiConstants.API_SERVER_URL}${url}`, getHeaders()),

  fetchAuthPut: (url, data) => axios.put(`${apiConstants.API_SERVER_URL}${url}`, data, getHeaders()),

  fetchAuthPatch: (url, data) => axios.patch(`${apiConstants.API_SERVER_URL}${url}`, data, getHeaders()),

  fetchAuthPost: (url, data) => axios.post(`${apiConstants.API_SERVER_URL}${url}`, data, getHeaders()),

  fetchAuthDelete: (url, data) => axios.delete(`${apiConstants.API_SERVER_URL}${url}`, data, getHeaders()),

  fetchWithUserAuthPost: (url, data, user) => axios.post(`${apiConstants.API_SERVER_URL}${url}`, data, {
    headers: {
      'Authorization': `Token ${user.token}`,
    }
  }),
}

function getHeaders(){
  return {
    headers: {
      'Authorization': `Basic ${userActions.getCurrentToken()}`,
    }
  }
}

/** Handle Response */
function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    userActions.logout()
    //location.reload(true)
    const error = (response.data && response.data.message) || response.statusText
    return Promise.reject(error)
  }else {
    return response.data
  }
}

